import { auth } from "@/lib/firebase"
import { useQuery } from "@tanstack/react-query"
import { z } from "zod"

// Define the schema for dashboard stats
export const DashboardStatsSchema = z.object({
	total_documents: z.number(),
	recent_cases: z.number(),
	days_period: z.number(),
})

export type DashboardStats = z.infer<typeof DashboardStatsSchema>

const fetchDashboardStats = async (days: number): Promise<DashboardStats> => {
	const user = auth.currentUser
	if (!user) {
		throw new Error("User not found.")
	}
	const token = await user.getIdToken()
	const response = await fetch(
		`${import.meta.env.VITE_API_URL}/api/stats/dashboard/?days=${days}`,
		{ headers: { Authorization: `Bearer ${token}` } }
	)
	if (!response.ok) {
		throw new Error(`HTTP error! status: ${response.status}`)
	}
	const rawData = await response.json()
	return DashboardStatsSchema.parse(rawData)
}

export const useDashboardStats = (days: number = 7) => {
	return useQuery<DashboardStats, Error>({
		queryKey: ["dashboardStats", days],
		queryFn: () => fetchDashboardStats(days),
	})
}
